const STYLES = {
  active: "bg-emerald-50 text-emerald-700 ring-emerald-600/10",
  assigned: "bg-emerald-50 text-emerald-700 ring-emerald-600/10",
  pending: "bg-amber-50 text-amber-800 ring-amber-600/15",
  overdue: "bg-red-50 text-red-700 ring-red-600/10",
  matched: "bg-emerald-50 text-emerald-700 ring-emerald-600/10",
  partial: "bg-orange-50 text-orange-700 ring-orange-600/10",
  open: "bg-primary/5 text-primary ring-primary/10",
  closed: "bg-slate-100 text-slate-600 ring-slate-500/10",
  processing: "bg-blue-50 text-blue-700 ring-blue-600/10",
  failed: "bg-red-50 text-red-800 ring-red-600/15",
  cancelled: "bg-slate-100 text-slate-700 ring-slate-500/15",
  canceled: "bg-slate-100 text-slate-700 ring-slate-500/15",
  completed: "bg-emerald-50 text-emerald-800 ring-emerald-600/15",
  delivered: "bg-emerald-50 text-emerald-700 ring-emerald-600/10",
  kept: "bg-emerald-50 text-emerald-700 ring-emerald-600/10",
  broken: "bg-red-50 text-red-700 ring-red-600/10",
  invited: "bg-sky-50 text-sky-700 ring-sky-600/10",
  suspended: "bg-slate-100 text-slate-600 ring-slate-500/10",
  inactive: "bg-amber-50 text-amber-800 ring-amber-600/15",
  deleted: "bg-red-50 text-red-800 ring-red-600/15",
};

const LABELS = {
  active: "Active",
  assigned: "Active",
  pending: "Pending",
  overdue: "Overdue",
  matched: "Matched",
  partial: "Partial",
  open: "Open",
  closed: "Closed",
  processing: "Processing",
  failed: "Failed",
  cancelled: "Cancelled",
  canceled: "Cancelled",
  completed: "Completed",
  delivered: "Delivered",
  kept: "Kept",
  broken: "Broken",
  invited: "Invited",
  suspended: "Suspended",
  inactive: "Inactive",
  deleted: "Deleted",
};

export default function StatusBadge({ status, label }) {
  const key = status?.toLowerCase?.() ?? "open";
  const style = STYLES[key] ?? STYLES.open;
  const display =
    label ??
    LABELS[key] ??
    (typeof status === "string" && status
      ? status.charAt(0).toUpperCase() + status.slice(1)
      : "Open");

  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 py-1 text-[11px] font-semibold ring-1 ring-inset ${style}`}
    >
      {key === "active" && (
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500" aria-hidden />
      )}
      {key === "invited" && (
        <span className="h-1.5 w-1.5 shrink-0 animate-pulse rounded-full bg-sky-500" aria-hidden />
      )}
      {display}
    </span>
  );
}
